var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},[_c('ul',{ref:"messages"},_vm._l((_vm.messages),function(item){return _c('Message',{key:item.sid,attrs:{"direction":item.author === _vm.identity ? 'incoming' : 'outgoing',"message":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }